export default __webpack_public_path__ + "static/char-s-38-zh-Hant-8be45a4220595c3101a9130518338ebc.png";